/*** IMPORTS FROM imports-loader ***/
import "core-js/modules/es.promise";
import "core-js/modules/es.array.iterator";

import { gsap, ScrollTrigger, Draggable, ScrollToPlugin  } from "gsap/all";

gsap.registerPlugin(ScrollTrigger, Draggable, ScrollToPlugin );

export default gsap;